module.exports = __webpack_public_path__ + "img/ic_link_bg_black.82ab9b57.svg";